<template>
  <div class="vs-wrap" :class="{ 'vs-loading': loading }">
    <select2 v-bind="$attrs" :settings="mergedSettings" :options="sortedOptions" />
    <span v-if="loading" class="vs-spinner" role="status" aria-label="Loading"></span>
  </div>
</template>

<script>
// Registered globally as <vue-select> (see main.js). Wraps vue3-select2-component
// and alphabetizes `options`. Pass `:sort="false"` for lists with a natural order
// (months, weekdays...).
import Select2 from "vue3-select2-component";
import { sortOptions } from "@/utils/sortOptions";

const labelOf = (option) =>
  option !== null && typeof option === "object"
    ? (option.text ?? option.label ?? option.name)
    : option;

export default {
  name: "SortedSelect2",

  components: { Select2 },

  inheritAttrs: false,

  props: {
    options: { type: Array, default: () => [] },
    sort: { type: Boolean, default: true },
    // Shows a spinner in the arrow area while the options are being fetched.
    loading: { type: Boolean, default: false },
  },

  computed: {
    // select2 sizes itself to the widest option by default, which overflows the
    // column when a long option exists; fit the parent instead.
    mergedSettings() {
      return { width: "100%", ...(this.$attrs.settings || {}) };
    },
    sortedOptions() {
      if (!this.sort || !Array.isArray(this.options)) return this.options;

      // Select2 option groups carry their items in `children`.
      const sortGroup = (option) =>
        option && Array.isArray(option.children)
          ? {
              ...option,
              children: sortOptions(option.children, labelOf, {
                valueKey: "id",
              }),
            }
          : option;

      return sortOptions(this.options.map(sortGroup), labelOf, {
        valueKey: "id",
      });
    },
  },
};
</script>
